export default "__VITE_ASSET__BODBY0Ns__"